export const ANOMALY_EXPORT_BUTTON_TEST_ID = "anomaly-export-button";
export const ANOMALY_EXPORT_BUTTON_TEXT = "Export";
